

const isEmptyValidation = (isEmptyField,setterFunction ,manualCondition) => {
    if (isEmptyField == null || isEmptyField === "" || isEmptyField.toString().trim() === "" || manualCondition) {
        setterFunction(true);
        return false;
    }
    else {
        setterFunction(false);
        return true;
    }
}

export default isEmptyValidation